module.exports = __webpack_public_path__ + "static/img/honour5.a0746830.png";